/**
 * 슬라이드 종류
 * https://github.kakaocorp.com/kakaopage/api/blob/8c8b6359b2a0c58c7946af8074a7095f465876e4/common/src/main/java/com/kakaopage/common/model/enums/SlideType.java#L20
 */
export enum SlideTypeVo {
  None = 'NONE',
  Slide = 'SD01',
  EPUB = 'SD02',
  Comic = 'SD03',
  AudioBook = 'SD04',
  VideoOnly = 'SD05',
  VOD = 'SD06',
  TalkNovel = 'SD07',
  TalkHumor = 'SD08',
}
